import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import {
  Link,
  Logo,
  Page,
} from 'components';
import { useWindowDimensions } from 'hooks';
import { APP_VERSION, BUILD_VERSION } from 'settings';

import useStyles from './styles';

function LayoutAuth({ children, title }) {
  const classes = useStyles();
  const { height, width } = useWindowDimensions();
  const { pathname } = useLocation();
  const isLogin = pathname === '/auth/login';
  const showWaves = !isLogin;
  const logoWidth = showWaves ? 250 : 160;
  const logoVariant = isLogin ? 'imagotipo-horizontal-dark' : 'imagotipo-horizontal';

  return (
    <div className={classes.root}>
      <Page
        maxWidth={isLogin ? false : 'lg'}
        title={title}
        className={`${classes.bg} ${!showWaves ? classes.bgLogin : ''} ${isLogin ? classes.pageNoGutters : ''}`}
      >
        <div className={classes.bgFullHeight}>

          {showWaves && <div className={classes.waves} />}
          {width > 1024 && height < 780
            ? (<div className={classes.back_footer} />)
            : null
          }

          {showWaves && (
            <div className={classes.container_icons}>
              {function () {
                const elems = [];
                [
                  {
                    size: 5,
                    value: '',
                  },
                  {
                    size: 8,
                    value: 'square_',
                  },
                ].forEach(({ size, value }) => {
                  for (let i = 1; i <= size; i++) {
                    elems.push(<div
                      className={classes[`icon_${value}${i}`]}
                    />);
                  }
                });

                return elems;
              }()}
            </div>
          )}

          <div className={`${classes.headerBar} ${!showWaves ? classes.headerBarLogin : ''}`}>
            <Box
              alignItems="center"
              children={<Logo
                style={isLogin ? {
                  maxHeight: 40,
                } : {
                  maxWidth: logoWidth,
                }}
                variant={logoVariant}
              />}
              className={`${classes.header_imagotipo} ${isLogin ? classes.header_imagotipo_login : ''}`}
              display="flex"
              mb={showWaves ? 5 : 0}
            />

            <Box
              alignItems="center"
              children={<Logo
                style={isLogin ? {
                  maxHeight: 40,
                } : {
                  maxWidth: logoWidth,
                }}
                variant={logoVariant}
              />}
              className={`${classes.header_isotipo} ${isLogin ? classes.header_isotipo_login : ''}`}
              display="flex"
              mb={showWaves ? 4 : 0}
            />
          </div>

          {children}

        </div>
      </Page>

      <footer className={classes.footer}>
        <Box lg={12} display="flex" alignItems="center" className={classes.footer_cont}>
          <div className={classes.footer_text}>
            <Typography
              children={`Versión ${APP_VERSION}.${BUILD_VERSION}`}
              color="textPrimary"
            />
          </div>
          <div className={classes.cont_policies}>
            <div className={classes.footer_text}>

            </div>
            <div className={classes.footer_text}>
              <Link to="/privacy_notice">
                <Typography
                  children="Aviso de privacidad"
                  color="textPrimary"
                />
              </Link>
            </div>
          </div>
        </Box>
      </footer>

    </div>
  );
};

LayoutAuth.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default LayoutAuth;
